export const RegexpHelper = {
  // eslint-disable-next-line
  URL: /(https?:\/\/[\w/:%#\$&\?\(\)~\.=\+\-]+)/g,
};
